import { AuthClient } from '@supabase/auth-js';

type AuthClientInstance = InstanceType<typeof AuthClient>;
import { config, isConfigured } from './config';

/**
 * O Supabase no browser serve apenas para autenticação (ADR-003): usamos só o cliente
 * de Auth, não o supabase-js completo (PostgREST, Realtime, Storage ficam fora do bundle).
 */
export const auth: AuthClientInstance | null = isConfigured
  ? new AuthClient({
      url: `${config.supabaseUrl}/auth/v1`,
      headers: { apikey: config.supabaseKey!, Authorization: `Bearer ${config.supabaseKey!}` },
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    })
  : null;
